/* eslint-disable react-hooks/exhaustive-deps */
import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    deleteFilterPAFAA010Conditions,
    fetchInitialConditions,
    saveFilterPAFAA010Conditions,
    saveMatchingConditions,
} from '../../../redux/reducers/PAFAA010';
import { getPAAAA010resume, getPAFAA010search, postPAFAA010list, putPAAAA010Banner } from '../../../services/Api';
import Checkbox from '../../../shared/components/Checkbox';
import Dropdown from '../../../shared/components/Dropdown';
import Nav from '../../../shared/components/Nav';
import Pagination from '../../../shared/components/Pagination';
import Radiobox from '../../../shared/components/Radiobox';
import Tabs from '../../../shared/components/Tabs';

import ResumeList from '../../../shared/components/ResumeList';
import { MENU_RESUME, MESSAGE } from '../../../shared/constants/app';
import { decodeToken, getCheckBoxValues, getDropdownValue, getRadioBoxValue } from '../../../utils';
import store from '../../../redux/store';

registerLocale('ko', ko);

const PAFAA010 = () => {
    const [loading, setLoading] = useState(false);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [resumeLicenses, setResumeLicenses] = useState([]);
    const [resumeForms, setResumeForms] = useState([]);
    const [resumePositions, setResumePositions] = useState([]);
    const [resumePays, setResumePays] = useState([]);
    const [checkedLabels, setCheckedLabels] = useState([]);
    const [resumeCareers, setResumeCareers] = useState([]);

    const [resumeClass, setResumeClass] = useState([]);
    const [resumeProvinces, setResumeProvinces] = useState([]);
    const [resumeCommunes, setResumeCommunes] = useState({});
    const [selectedProvince, setSelectedProvince] = useState(null);

    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [checkedValues, setCheckedValues] = useState({});
    const [checkedLikeRightValues, setCheckedLikeRightValues] = useState({});
    const [resumeRegionChecked, setResumeRegionChecked] = useState({
        RegionSi: [],
        RegionGu: [],
    });
    const [resumeRegion, setResumeRegion] = useState({});

    const [results, setResults] = useState([]);
    const [size, setSize] = useState(50);
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});
    const [sortBy, setSortBy] = useState('ModDate');

    const [conditionSearch, setConditionSearch] = useState('Title');
    const [keywords, setKeywords] = useState([]);

    const dispatch = useDispatch();

    const savedConditions = useSelector(({ PAFAA010 }) => PAFAA010.savedPAFAA010Conditions);
    const [savedConditionsPopup, setSavedConditionsPopup] = useState(false);
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const login = useSelector(({ auth }) => auth.login);
    const loggedIn = login.loggedIn;
    const navigate = useNavigate();
    const popupRef = useRef(null);

    // useEffect(() => {
    //     if (!loggedIn || decode?.authorities === 'ROLE_P') {
    //         alert('인재정보는 치과회원만 확인하실 수 있습니다.');
    //         navigate('/');
    //     }
    // }, [decode, navigate]);

    const [resumeBanner, setResumeBanner] = useState([]);
    const [dataConFig, setDataConFig] = useState({
        bannerConfig: '',
    });

    const [activeTabCheckbox, setActiveTabCheckbox] = useState(null);
    const [resetTrigger, setResetTrigger] = useState(0);

    const getOptions = (name) => {
        const options = {
            ResumeLicense: resumeLicenses.map((license) => ({
                id: 'resumeLicenses_' + license.code,
                label: license.codeName,
                value: license.code,
            })),

            ResumeForm: resumeForms.map((form) => ({
                id: 'resumeForms_' + form.code,
                label: form.codeName,
                value: form.code,
            })),

            ResumePosition: resumePositions.map((position) => ({
                id: 'resumePositions_' + position.code,
                label: position.codeName,
                value: position.code,
            })),

            ResumePay: resumePays.map((pay) => ({
                id: 'resumePays_' + pay.code,
                label: pay.codeName,
                value: pay.code,
            })),

            ResumeCareer: resumeCareers.map((career) => ({
                id: 'resumeCareers_' + career.code,
                label: career.codeName,
                value: career.code,
            })),

            ResumeCareerYear: [
                { value: '1', option: '1년' },
                { value: '2', option: '2년' },
                { value: '3', option: '3년' },
                { value: '4', option: '4년' },
                { value: '5', option: '5년' },
                { value: '6', option: '6년' },
                { value: '7', option: '7년' },
                { value: '8', option: '8년' },
                { value: '9', option: '9년' },
                { value: '10', option: '10년' },
                { value: '11', option: '11년' },
                { value: '12', option: '12년' },
                { value: '13', option: '13년' },
                { value: '14', option: '14년' },
                { value: '15', option: '15년' },
                { value: '16', option: '16년' },
                { value: '17', option: '17년' },
                { value: '18', option: '18년' },
                { value: '19', option: '19년' },
                { value: '20', option: '20년' },
                { value: '21', option: '21년' },
                { value: '22', option: '22년' },
                { value: '23', option: '23년' },
                { value: '24', option: '24년' },
                { value: '25', option: '25년' },
                { value: '26', option: '26년' },
                { value: '27', option: '27년' },
                { value: '28', option: '28년' },
                { value: '29', option: '29년' },
                { value: '30', option: '30년' },
            ],
            ResumeClass: resumeClass.map((item) => ({
                id: 'resumeClass_' + item.code,
                label: item.codeName,
                value: item.code,
            })),
        };
        return options[name];
    };

    const arrTabCheckbox = {
        0: (resumeProvinces?.filter((p) => p.code === '001') || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        1: (resumeProvinces?.filter((p) => p.code === '003') || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        2: (resumeProvinces?.filter((p) => p.code === '008') || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        3: (resumeProvinces?.filter((p) => p.code === '009') || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),

        4: (resumeProvinces?.filter((p) => ['006', '010', '011', '017'].includes(p.code)) || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        5: (resumeProvinces?.filter((p) => ['002', '004', '007', '014', '015'].includes(p.code)) || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
        6: (resumeProvinces?.filter((p) => ['005', '012', '013', '016'].includes(p.code)) || []).map((p) => ({
            id: `RecruitLicense_${p.code}`,
            value: p.code,
            label: p.codeName,
        })),
    };
    const tabCheckbox = [
        { label: '서울', isActive: false },
        { label: '인천', isActive: false },
        { label: '경기권', isActive: false },
        { label: '강원권', isActive: false },
        { label: '충청권', isActive: false },
        { label: '영남권', isActive: false },
        { label: '호남/제주권', isActive: false },
    ];

    // tabs
    const handleTabChange = (index) => {
        setActiveTabIndex(index);

        // Nếu chuyển giữa nhóm tab (1,2) <-> 4 thì reset
        const isCurrentTabGroup1or2 = activeTabIndex === 0 || activeTabIndex === 1;
        const isCurrentTabGroup4 = activeTabIndex === 3;
        const isNextTabGroup1or2 = index === 0 || index === 1;
        const isNextTabGroup4 = index === 3;

        if ((isCurrentTabGroup4 && isNextTabGroup1or2) || (isCurrentTabGroup1or2 && isNextTabGroup4)) {
            handleResetConditions();
            setCheckedValues((prev) => {
                const newValues = { ...prev };
                delete newValues.RegionSi;
                delete newValues.RegionGu;
                return newValues;
            });
            setActiveTabCheckbox(null);
        }
    };

    // dropdown
    const handleOptionChange = (selectedValue, name) => {
        switch (name) {
            case 'size':
                setSize(selectedValue);
                break;
            case 'sortBy':
                setSortBy(selectedValue);
                break;
            case 'conditionSearch':
                setConditionSearch(selectedValue);
                break;
            default:
                setCheckedValues((checkedValues) => getDropdownValue(checkedValues, name, selectedValue));
                break;
        }
    };

    // select box, radio box
    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;

        if (name === 'RegionSi') {
            handleRegionSiClick(value);
        }

        setResumeRegion((checkedValues) => {
            let newCheckedValues = JSON.parse(JSON.stringify(checkedValues));

            const selectedRegionSi = Object.entries(resumeCommunes).find(([key, communes]) =>
                communes.some((commune) => commune.code === value),
            );

            if (selectedRegionSi) {
                const [regionSiCode] = selectedRegionSi;
                const currentRegionGu = newCheckedValues[regionSiCode] || [];

                if (checked) {
                    if (value.endsWith('00')) {
                        newCheckedValues[regionSiCode] = [value];

                        setCheckedValues((prevChecked) => {
                            const updatedChecked = { ...prevChecked };
                            if (!updatedChecked.RegionGu) updatedChecked.RegionGu = [];

                            const guToRemove = (resumeCommunes[regionSiCode] || []).map((c) => c.code);

                            updatedChecked.RegionGu = updatedChecked.RegionGu.filter(
                                (code) => !guToRemove.includes(code),
                            );

                            updatedChecked.RegionGu = updatedChecked.RegionGu.filter(
                                (code) => !(code.endsWith('00') && code !== value),
                            );

                            if (!updatedChecked.RegionGu.includes(value)) {
                                updatedChecked.RegionGu.push(value);
                            }

                            return updatedChecked;
                        });
                    } else {
                        if (currentRegionGu.some((guCode) => guCode.endsWith('00'))) {
                            newCheckedValues[regionSiCode] = currentRegionGu.filter((guCode) => !guCode.endsWith('00'));
                            setCheckedValues((prev) => ({
                                ...prev,
                                RegionGu: (prev.RegionGu || []).filter((code) => !code.endsWith('00')),
                            }));
                        }

                        if (currentRegionGu.length > 10) return checkedValues;

                        if (!newCheckedValues[regionSiCode]) newCheckedValues[regionSiCode] = [];
                        if (!newCheckedValues[regionSiCode].includes(value)) {
                            newCheckedValues[regionSiCode].push(value);
                        }

                        setCheckedValues((prev) => {
                            const updated = { ...prev };
                            const newList = new Set([...(updated.RegionGu || []), value]);
                            updated.RegionGu = Array.from(newList);
                            return updated;
                        });
                    }
                } else {
                    if (newCheckedValues[regionSiCode]) {
                        newCheckedValues[regionSiCode] = newCheckedValues[regionSiCode].filter(
                            (guCode) => guCode !== value,
                        );
                        if (newCheckedValues[regionSiCode].length === 0) {
                            delete newCheckedValues[regionSiCode];
                        }
                    }

                    setCheckedValues((prev) => {
                        const updated = { ...prev };
                        if (updated.RegionGu) {
                            updated.RegionGu = updated.RegionGu.filter((code) => code !== value);
                            if (updated.RegionGu.length === 0) delete updated.RegionGu;
                        }
                        return updated;
                    });
                }
            }

            return newCheckedValues;
        });

        setCheckedValues((checkedValues) => {
            let newCheckedValues = JSON.parse(JSON.stringify(checkedValues));

            if (type === 'checkbox') {
                newCheckedValues = getCheckBoxValues(newCheckedValues, name, value, checked);
            } else if (type === 'radio') {
                if (name === 'ResumeCareer' && value !== '경력') {
                    delete newCheckedValues.expMin;
                    delete newCheckedValues.expMax;
                }
                newCheckedValues = getRadioBoxValue(newCheckedValues, name, value, checked);
            }

            return newCheckedValues;
        });
    };

    // datetime input
    // const handleDateChange = (date, name) => {
    //     if (name === 'startDate') {
    //         setStartDate(date);
    //     } else if (name === 'endDate') {
    //         setEndDate(date);
    //     }
    // };

    useEffect(() => {
        if (resumeProvinces.length > 0) {
            setSelectedProvince(resumeProvinces[0].code);
        }
    }, [resumeProvinces]);

    // tab 1
    const handleProvinceClick = (code) => {
        setSelectedProvince(code);
    };

    const communesToRender = resumeCommunes[selectedProvince] || [];

    const handleCheckResumeClass = (code) => {
        setCheckedLikeRightValues((prevValues) => {
            const newValues = { ...prevValues };
            const resumeClass = newValues['ResumeClass'] || [];

            if (resumeClass.includes(code)) {
                newValues['ResumeClass'] = resumeClass.filter((item) => item !== code);
            } else {
                newValues['ResumeClass'] = [...resumeClass, code];
            }

            if (newValues['ResumeClass'].length === 0) {
                delete newValues['ResumeClass'];
            }

            return newValues;
        });
    };

    const handleInputKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();

            const inputValue = e.target.value.trim();
            const inputName = e.target.name;

            if (inputValue) {
                if (keywords.length >= 3) {
                    return;
                }

                setCheckedLikeRightValues((prevValues) => {
                    const newValues = { ...prevValues };

                    if (inputName === 'searchAll') {
                        // thêm inputValue vào 'Title' và 'ResumeContent'
                        ['Title', 'ResumeContent'].forEach((key) => {
                            if (!newValues[key]) {
                                newValues[key] = [];
                            }

                            // thêm giá trị vào khóa tương ứng nếu nó chưa có ở đó
                            if (!newValues[key].includes(inputValue)) {
                                newValues[key].push(inputValue);
                            }
                        });
                    } else {
                        if (!newValues[conditionSearch]) {
                            newValues[conditionSearch] = [];
                        }
                        const updatedKeywords = [...newValues[conditionSearch], inputValue];
                        newValues[conditionSearch] = [...new Set(updatedKeywords)];
                    }

                    return newValues;
                });

                setKeywords((prevKeywords) => {
                    const updatedKeywords = [...prevKeywords, inputValue];
                    return [...new Set(updatedKeywords)];
                });

                e.target.value = '';
            }
        }
    };

    // get label
    const getCheckedLabels = () => {
        const labels = [];
        const startDateChecked =
            startDate !== undefined && moment(startDate).isValid() ? moment(startDate).format('yyyy-MM-DD') : '';
        const endDateChecked =
            endDate !== undefined && moment(endDate).isValid() ? moment(endDate).format('yyyy-MM-DD') : '';

        // lấy label từ checkedLikeRightValues

        checkedLikeRightValues &&
            Object.entries(checkedLikeRightValues).forEach(([key, values]) => {
                if (key === 'ResumeClass') {
                    const valueArray = Array.isArray(values) ? values : [values];
                    valueArray.forEach((code) => {
                        const resume = resumeClass?.find((item) => item.code === code);

                        if (resume) {
                            labels.push(resume.codeName);
                        }
                    });
                }
            });

        // lấy label từ checkedValues
        Object.entries(checkedValues).forEach(([key, values]) => {
            if (key === 'RegionGu') {
                const valueArray = Array.isArray(values) ? values : [values];

                valueArray.forEach((value) => {
                    // tìm RegionSi chứa RegionGu này
                    const regionSiEntry = Object.entries(resumeCommunes)?.find(([regionSiCode, communes]) =>
                        communes.some((commune) => commune.code === value),
                    );

                    if (regionSiEntry) {
                        const [regionSiCode] = regionSiEntry;

                        // tìm tên RegionSi từ recruitProvinces
                        const regionSi = resumeProvinces.find((province) => province.code === regionSiCode);

                        // tìm thông tin RegionGu
                        const commune = resumeCommunes[regionSiCode]?.find((commune) => commune.code === value);

                        if (regionSi && commune) {
                            labels.push(`${regionSi.codeName} > ${commune.codeName}`);
                        }
                    }
                });
            }

            const options = getOptions(key);
            const expMin = checkedValues.ExpMin !== undefined ? checkedValues.ExpMin + '년' : '';
            const expMax = checkedValues.ExpMax !== undefined ? checkedValues.ExpMax + '년' : '';

            if (!options) return;

            const valueArray = Array.isArray(values) ? values : [values];
            valueArray.forEach((value) => {
                const matchedOption = options?.find((option) => option.value === value);
                if (matchedOption) {
                    if (key === 'ResumeCareer' && value === '009') {
                        labels.push(`경력: ${expMin} ~ ${expMax}`);
                    } else {
                        labels.push(matchedOption.option || matchedOption.label); // Dùng option nếu có
                    }
                }
            });
        });

        if (keywords && keywords.length > 0) {
            keywords.forEach((keyword) => {
                labels.push(keyword);
            });
        }

        if (startDate || endDate) {
            labels.push(`채용기간: ${startDateChecked} ~ ${endDateChecked}`);
        }

        return [...new Set(labels)];
    };

    // remove label
    const handleRemoveLabel = (label) => {
        // xử lý xóa StartDate và EndDate
        if (label.startsWith('채용기간:')) {
            setStartDate('');
            setEndDate('');
        }

        setCheckedValues((prevValues) => {
            const newValues = { ...prevValues };
            const [regionSiName, regionGuName] = label.split(' > ');
            // duyệt qua các key trong checkedValues
            Object.entries(newValues).forEach(([key, values]) => {
                const options = getOptions(key);

                // xử lý xóa ResumeCareer với giá trị '경력'
                if (key === 'ResumeCareer' && label.startsWith('경력:')) {
                    // xóa expMin và expMax khi label là dạng 경력: X ~ Y
                    delete newValues.ExpMin;
                    delete newValues.ExpMax;
                    delete newValues[key];
                    return;
                }

                // xử lý RegionGu
                if (key === 'RegionGu') {
                    // tìm RegionSi liên kết với RegionGu từ recruitCommunes
                    const matchedCommune = Object.entries(resumeCommunes).find(([regionSiCode, communes]) => {
                        const regionSi = resumeProvinces.find((province) => province.code === regionSiCode);
                        return (
                            regionSi &&
                            regionSi.codeName === regionSiName &&
                            communes.some((commune) => commune.codeName === regionGuName)
                        );
                    });

                    if (matchedCommune) {
                        const [regionSiCode, communes] = matchedCommune;

                        // loại bỏ RegionGu được chọn khỏi checkedValues
                        const communeToRemove = communes.find((commune) => commune.codeName === regionGuName);
                        if (communeToRemove) {
                            newValues.RegionGu = newValues.RegionGu.filter((code) => code !== communeToRemove.code);
                            // nếu RegionGu trống, xóa luôn key RegionGu
                            if (newValues.RegionGu.length === 0) {
                                delete newValues.RegionGu;
                            }

                            // kiểm tra nếu RegionSi còn liên kết với các RegionGu khác
                            const remainingRegionGu = newValues.RegionGu || [];
                            const isRegionSiStillRelevant = communes.some((commune) =>
                                remainingRegionGu.includes(commune.code),
                            );

                            if (!isRegionSiStillRelevant) {
                                // loại bỏ RegionSi nếu không còn liên kết
                                newValues.RegionSi = (newValues.RegionSi || []).filter((code) => code !== regionSiCode);

                                if (newValues.RegionSi.length === 0) {
                                    delete newValues.RegionSi;
                                }
                            }
                        }
                    }
                }

                // xử lý các giá trị khác
                if (!options) return;

                // tìm value tương ứng với label
                const matchedOption = options.find((option) => option.label === label);
                if (matchedOption) {
                    if (Array.isArray(values)) {
                        // nếu là mảng (checkbox), loại bỏ giá trị tương ứng
                        newValues[key] = values.filter((value) => value !== matchedOption.value);
                        if (newValues[key].length === 0) {
                            delete newValues[key];
                        }
                    } else if (values === matchedOption.value) {
                        // nếu là giá trị đơn (radio, select), đặt lại giá trị
                        delete newValues[key];
                    }
                }
            });
            return newValues;
        });

        setCheckedLikeRightValues((prevValues) => {
            const newValues = { ...prevValues };
            // xóa dữ liệu trong checkedLikeRightValues
            Object.entries(prevValues).forEach(([key, values]) => {
                if (key === 'ResumeClass') {
                    values.forEach((code, index) => {
                        const resume = resumeClass.find((item) => item.code === code && item.codeName === label);

                        if (resume) {
                            newValues['ResumeClass'] = [...values.slice(0, index), ...values.slice(index + 1)];
                        }
                    });
                    if (newValues['ResumeClass'].length === 0) {
                        delete newValues['ResumeClass'];
                    }
                }
            });

            return newValues;
        });

        setResumeRegion((prevValues) => {
            const newValues = { ...prevValues };

            const [regionSiName, regionGuName] = label.split(' > ');

            const regionSi = resumeProvinces.find((province) => province.codeName === regionSiName);
            const regionSiCode = regionSi ? regionSi.code : null;

            let regionGuCode = null;
            if (regionSiCode) {
                const regionGu = resumeCommunes[regionSiCode]?.find((commune) => commune.codeName === regionGuName);
                if (regionGu) {
                    regionGuCode = regionGu.code;
                }
            }

            if (regionSiCode && regionGuCode) {
                if (newValues[regionSiCode]) {
                    newValues[regionSiCode] = newValues[regionSiCode].filter((code) => code !== regionGuCode);

                    if (newValues[regionSiCode].length === 0) {
                        delete newValues[regionSiCode];
                    }
                }
            }

            return newValues;
        });

        // xóa khỏi keywords và các trường 'Title', 'ResumeContent'
        const isKeywordLabel = label && keywords.includes(label); // kiểm tra có trong keywords list không

        if (isKeywordLabel) {
            // xóa keyword khỏi `keywords` state
            const keywordToRemove = label;

            setKeywords((prevKeywords) => {
                return prevKeywords.filter((keyword) => keyword !== keywordToRemove);
            });

            // xóa keyword khỏi `Title`, `ResumeContent` trong checkedLikeRightValues
            setCheckedLikeRightValues((prevValues) => {
                const newValues = { ...prevValues };

                ['Title', 'ResumeContent'].forEach((field) => {
                    if (newValues[field]) {
                        // loại bỏ keyword khỏi các trường này
                        newValues[field] = newValues[field].filter((value) => value !== keywordToRemove);

                        // nếu trống sau khi xóa keyword, xóa luôn key đó
                        if (newValues[field].length === 0) {
                            delete newValues[field];
                        }
                    }
                });

                return newValues;
            });
        }

        // xóa label khỏi danh sách `checkedLabels`
        setCheckedLabels((prevLabels) => prevLabels.filter((l) => l !== label));
    };

    useEffect(() => {
        if (loggedIn) {
            dispatch(fetchInitialConditions());
        }
    }, [dispatch, loggedIn]);

    const handleSaveConditions = () => {
        if (window.location.pathname !== '/login' && window.location.pathname !== '/' && !loggedIn) {
            if (window.confirm(`회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`)) {
                navigate('/login');
            } else {
                alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                navigate('/');
            }
            return;
        }

        const savedDate = moment().format('YYYY/MM/DD');
        if (
            Object.keys(checkedLikeRightValues).length === 0 &&
            Object.keys(checkedValues).length === 0 &&
            Object.keys(resumeRegion).length === 0 &&
            startDate === '' &&
            endDate === '' &&
            checkedLabels.length === 0
        )
            return;

        const currentConditions = store.getState().PAFAA010.savedPAFAA010Conditions;
        console.log('currentConditions', currentConditions);
        if (currentConditions.length >= 5) {
            window.alert('저장가능한 개수는 5개 입니다.');
            return;
        }

        dispatch(
            saveFilterPAFAA010Conditions({
                checkedLikeRightValues,
                resumeRegion,
                checkedValues,
                startDate: startDate ? moment(startDate).format('YYYY/MM/DD') : '',
                endDate: endDate ? moment(endDate).format('YYYY/MM/DD') : '',
                savedDate,
                checkedLabels,
                activeTabIndex,
                activeTabCheckbox,
            }),
        );

        dispatch(saveMatchingConditions(decode.seq));

        window.alert(MESSAGE.notify.saveSuccess);
    };

    const handleResetConditions = () => {
        setResetTrigger((prev) => prev + 1);
        setCheckedLikeRightValues({});
        setCheckedValues({});
        setCheckedLabels([]);
        setStartDate('');
        setEndDate('');
        setKeywords([]);
        setResumeRegion({});
        setActiveTabCheckbox(null);
        setCheckedRegionSi(null);
    };

    useEffect(() => {
        const regionSi = Object.keys(resumeRegion || {});
        const regionGu = Object.values(resumeRegion || {}).flat();

        setResumeRegionChecked({
            RegionSi: regionSi,
            RegionGu: regionGu,
        });
    }, [resumeRegion]);

    useEffect(() => {
        setCheckedLabels(getCheckedLabels);
        // eslint-disable-next-line
    }, [checkedValues, checkedLikeRightValues, resumeClass, startDate, endDate]);

    useEffect(() => {
        getPAFAA010search()
            .then(({ data }) => {
                setResumeProvinces(data.resumeProvinces);
                setResumeCommunes(data.resumeCommunes);
                setResumeClass(data.resumeClass);
                setResumeLicenses(data.resumeLicense);
                setResumeForms(data.resumeForm);
                setResumePositions(data.resumePosition);
                setResumePays(data.resumePay);
                setResumeCareers(data.resumeCareer);
            })
            .catch((error) => console.log(error));

        getPAAAA010resume()
            .then(({ data }) => {
                setResumeBanner(data.resume);
                const listSeq = [data.resume?.map((item) => item.seq).join(',')].filter((seq) => seq).join(',');
                if (listSeq.toString() === '') return;
                putPAAAA010Banner(listSeq.toString())
                    .then()
                    .catch((error) => console.log(error));
            })
            .catch((error) => console.log(error));
    }, []);

    const getListData = (currentPage = page) => {
        // if (!loggedIn || decode?.authorities === 'ROLE_P') {
        //     setLoading(false);
        //     setResults([]);
        //     return;
        // }

        setLoading(true);
        setResults([]);
        const startDateFormat = startDate === '' ? null : moment(startDate).format('yyyy-MM-DD');
        const endDateFormat = endDate === '' ? null : moment(endDate).format('yyyy-MM-DD');
        let optionLike = checkedValues && Object.keys(checkedValues).length === 0 ? null : checkedValues;
        const optionLikeRight =
            checkedLikeRightValues && Object.keys(checkedLikeRightValues).length === 0 ? null : checkedLikeRightValues;
        const region = Object.keys(resumeRegion).length === 0 ? null : resumeRegion;
        const filteredRegion = region
            ? Object.fromEntries(Object.entries(region).filter(([key]) => checkedValues?.RegionSi?.includes(key)))
            : null;
        const expMin = checkedValues?.ExpMin?.[0] || '';
        const expMax = checkedValues?.ExpMax?.[0] || '';

        let optionLikeCopy = { ...optionLike };
        delete optionLikeCopy.RegionSi;
        delete optionLikeCopy.RegionGu;
        delete optionLikeCopy.ExpMin;
        delete optionLikeCopy.ExpMax;

        if (optionLikeCopy && optionLikeCopy.ResumeCareer) {
            const arr = optionLikeCopy.ResumeCareer;
            if (Array.isArray(arr) && arr.length === 1 && arr[0] === "999") {
                delete optionLikeCopy.ResumeCareer;
            }
        }

        if (options && Array.isArray(options.RegionGu)) {
            const filteredRegionGu = options.RegionGu.filter((value) => {
                const numValue = parseInt(value);
                const isDivisibleBy100 = Number.isInteger(numValue) && numValue % 100 === 0;
                const endsWithZeros = value.endsWith('00');
                return !isDivisibleBy100 && !endsWithZeros;
            });

            if (filteredRegionGu.length === 0) {
                const { RegionGu, ...restOptions } = options;
                options = Object.keys(restOptions).length === 0 ? null : restOptions;
            } else {
                options = { ...options, RegionGu: filteredRegionGu };
            }
        }


        postPAFAA010list({
            options: (optionLikeCopy = Object.keys(optionLikeCopy).length === 0 ? null : optionLikeCopy),
            optionLikeRight,
            resumeRegion: activeTabIndex === 3 ? filteredRegion : region,
            startDate: startDateFormat,
            endDate: endDateFormat,
            expMin,
            expMax,
            size,
            page: currentPage,
            sortBy,
        })
            .then(({ data }) => {
                setResults(data.data.list);
                setPages(data.info);
                setDataConFig({
                    bannerConfig: data.data.bannerConfig,
                });
            })
            .catch((error) => console.log(error))
            .finally(() => {
                setLoading(false);
            });
    };

    const handleSearchClick = () => {
        setSearchParams({ ...searchParams, page: 1 });
        getListData(1);
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, size, sortBy]);

    const [checkedPin, setCheckedPin] = useState(false);
    const handleSelectSavedCondition = (index) => {
        setCheckedPin(true);

        const item = savedConditions[index];
        if (!item) return;

        const {
            resumeRegionStore,
            checkedStoreValues,
            checkedLikeRightStoreValues,
            startStoreDate,
            endStoreDate,
            checkedStoreLabels,
        } = item;

        if (typeof item.activeTabIndex === 'number') {
            setActiveTabIndex(item.activeTabIndex);
        }
        if (typeof item.activeTabCheckbox !== 'undefined') {
            setActiveTabCheckbox(item.activeTabCheckbox);
        }

        setCheckedValues(checkedStoreValues);
        setCheckedLikeRightValues(checkedLikeRightStoreValues);
        setStartDate(startStoreDate);
        setEndDate(endStoreDate);
        setResumeRegion(resumeRegionStore);
        setCheckedLabels(checkedStoreLabels);

        const keywordSet = new Set();
        if (checkedLikeRightStoreValues && !checkedLikeRightStoreValues['ResumeClass']) {
            Object.values(checkedLikeRightStoreValues).forEach((keywords) => {
                keywords.forEach((keyword) => keywordSet.add(keyword));
            });
        }
        setKeywords([...keywordSet]);
    };

    const handleClickOutSidePopup = (e) => {
        if (popupRef.current && !popupRef.current.contains(e.target)) {
            setSavedConditionsPopup(false);
        }
    };

    useEffect(() => {
        if (savedConditionsPopup) {
            document.addEventListener('mousedown', handleClickOutSidePopup);
            return () => {
                document.removeEventListener('mousedown', handleClickOutSidePopup);
            };
        }
    }, [savedConditionsPopup]);

    const handleTabtabSelectCheckbox = (index) => {
        setCheckedPin(false);
        setActiveTabCheckbox(index);
    };
    const [checkedRegionSi, setCheckedRegionSi] = useState(null);
    const communesToRenderTab3 = checkedValues?.RegionSi?.[0]
        ? resumeCommunes[checkedValues.RegionSi[0]]
        : resumeCommunes[checkedRegionSi] || [];
    const options = arrTabCheckbox[activeTabCheckbox];
    useEffect(() => {
        if (options?.length > 0 && options[0]?.value && !checkedPin) {
            setCheckedValues((prev) => ({
                ...prev,
                RegionSi: [options[0]?.value],
            }));
            setCheckedRegionSi(options[0]?.value);
        }
    }, [activeTabCheckbox]);

    useEffect(() => {
        if (communesToRenderTab3?.length > 0 && communesToRenderTab3[0]?.code && activeTabIndex === 3 && !checkedPin) {
            setCheckedValues((prev) => ({
                ...prev,
                RegionGu: [communesToRenderTab3[0]?.code],
            }));
            setResumeRegion({
                [checkedRegionSi ? checkedRegionSi : options[0]?.value]: [communesToRenderTab3[0]?.code],
                RegionSi: [checkedRegionSi ? checkedRegionSi : options[0]?.value],
                RegionGu: [communesToRenderTab3[0]?.code],
            });
        }
    }, [activeTabCheckbox, communesToRenderTab3]);

    const handleRegionSiClick = (value) => {
        setCheckedPin(false);
        setCheckedRegionSi(value);
    };

    return (
        <div id="content">
            <Nav menu={MENU_RESUME} />
            <div id="tabs-form" className="container">
                <div className="top-form">
                    <h2>통합</h2>
                    <div ref={popupRef}>
                        <button
                            id="saved-conditions"
                            data-type="popup"
                            onClick={() => {
                                if (
                                    window.location.pathname !== '/login' &&
                                    window.location.pathname !== '/' &&
                                    !loggedIn
                                ) {
                                    if (
                                        window.confirm(
                                            `회원전용입니다.\n로그인 하신후 이용하실 수 있습니다.\n로그인하시겠습니까?`,
                                        )
                                    ) {
                                        navigate('/login');
                                    } else {
                                        alert(`회원이 아닌경우 회원가입후 이용가능합니다.`);
                                        navigate('/');
                                    }
                                }
                                setSavedConditionsPopup(!savedConditionsPopup);
                            }}
                        >
                            <span>저장한 조건 보기</span>
                            <i className="icon icon-down" />
                        </button>
                        <div className={`popup ${savedConditionsPopup ? 'active' : ''}`} htmlFor="saved-conditions">
                            <button
                                className="popup-close"
                                onClick={() => {
                                    setSavedConditionsPopup(false);
                                }}
                            />
                            <div className="popup-header">
                                최근 저장한 검색 조건<span>(보관은 최대 5개까지 가능)</span>
                            </div>
                            <div className="popup-content">
                                <ul className="table table-content">
                                    <li className="row-name-column">
                                        <div className="column start">검색조건</div>
                                        <div className="column start">검색일</div>
                                        <div className="column">삭제</div>
                                    </li>
                                    {savedConditions.map((item, index) => (
                                        <li key={index}>
                                            <ul className="wrap-link" onClick={() => handleSelectSavedCondition(index)}>
                                                {Array.isArray(item.checkedStoreLabels) &&
                                                    item.checkedStoreLabels.map((label, index) => (
                                                        <li key={index}>{label}</li>
                                                    ))}
                                            </ul>
                                            <span className="date">{item.savedStoreDate}</span>
                                            <button
                                                className="delete"
                                                onClick={() => {
                                                    dispatch(deleteFilterPAFAA010Conditions(index));
                                                    dispatch(saveMatchingConditions(decode.seq));
                                                }}
                                            >
                                                <i className="icon icon-trash"></i>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <Tabs
                    tabs={[
                        { label: '지역 선택', icon: 'icon-location', isActive: true },
                        { label: '업무 선택', icon: 'icon-bag', isActive: false },
                        {
                            label: (
                                <input
                                    type="text"
                                    placeholder="검색어 입력"
                                    name="searchAll"
                                    className="focus-none"
                                    onKeyPress={handleInputKeyPress}
                                    style={{ width: '100%' }}
                                />
                            ),
                            icon: 'icon-search',
                            isActive: false,
                        },
                        { label: '상세조건', icon: 'icon-plus', isActive: false },
                    ]}
                    blackTab
                    onTabChange={handleTabChange}
                    indexTabchange={activeTabIndex}
                />
                {activeTabIndex === 0 && (
                    <>
                        <div className="tab tabs-select">
                            <div className="tabs-flex">
                                <div className="tabs-left">
                                    <ul>
                                        {resumeProvinces.map((province, index) => (
                                            <li
                                                className={province.code === selectedProvince ? 'active' : ''}
                                                key={index}
                                                onClick={() => handleProvinceClick(province.code)}
                                            >
                                                <span className="city-name">{province.codeName}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="tabs-right">
                                    <form>
                                        {communesToRender.length > 0 && (
                                            <>
                                                <p className="notification">
                                                    지역은 최대 <span>10</span>개까지 선택 가능합니다.
                                                </p>
                                                <ul>
                                                    <Checkbox
                                                        name="RegionGu"
                                                        options={communesToRender.map((commune) => ({
                                                            id: 'regionGu_' + commune.code,
                                                            value: commune.code,
                                                            label: `${commune.codeName}`,
                                                        }))}
                                                        onChange={handleInputChange}
                                                        checked={resumeRegionChecked}
                                                    />
                                                </ul>
                                            </>
                                        )}
                                    </form>
                                </div>
                            </div>
                            <div className="bsns-srch">
                                <Dropdown
                                    placeholder=""
                                    options={[
                                        { value: 'Title', option: '제목' },
                                        { value: 'ResumeContent', option: '내용' },
                                    ]}
                                    value={conditionSearch}
                                    name="conditionSearch"
                                    onChange={handleOptionChange}
                                />
                                <input type="text" placeholder="검색어 입력하세요" onKeyPress={handleInputKeyPress} />
                            </div>{' '}
                        </div>
                    </>
                )}
                {activeTabIndex === 1 && (
                    <>
                        <div
                            className={`tab tabs-select tabs-select-bag tab-${resumeClass && resumeClass.length % 4 === 0 ? 4 : 5
                                }-item`}
                        >
                            <ul>
                                {resumeClass.map((resume) => (
                                    <li
                                        key={resume.code}
                                        onClick={() => handleCheckResumeClass(resume.code)}
                                        className={
                                            checkedLikeRightValues['ResumeClass']?.includes(resume.code) ? 'active' : ''
                                        }
                                    >
                                        {resume.codeName}
                                    </li>
                                ))}
                            </ul>
                            <div className="bsns-srch">
                                <Dropdown
                                    placeholder=""
                                    options={[
                                        { value: 'Title', option: '제목' },
                                        { value: 'ResumeContent', option: '내용' },
                                    ]}
                                    value={conditionSearch}
                                    name="conditionSearch"
                                    onChange={handleOptionChange}
                                />
                                <input type="text" placeholder="검색어 입력하세요" onKeyPress={handleInputKeyPress} />
                            </div>
                        </div>
                    </>
                )}
                {activeTabIndex === 3 && (
                    <div className="tab tabs-content tabs-select-plus">
                        <div className="wrap-select-plus-child benefit">
                            <div className="title-detailed">업무</div>
                            <ul className="tab-check-box">
                                <Checkbox
                                    name="ResumeClass"
                                    options={getOptions('ResumeClass')}
                                    onChange={handleInputChange}
                                    checked={checkedValues}
                                />
                            </ul>
                        </div>
                        <div className="wrap-select-plus-child">
                            <div className="title-detailed">자격증</div>
                            <ul className="tab-check-box">
                                <Checkbox
                                    name="ResumeLicense"
                                    options={getOptions('ResumeLicense')}
                                    onChange={handleInputChange}
                                    checked={checkedValues}
                                />
                            </ul>
                        </div>
                        <div className="wrap-select-plus-child">
                            <div className="title-detailed">근무형태</div>
                            <ul className="tab-check-box">
                                <Checkbox
                                    name="ResumeForm"
                                    options={getOptions('ResumeForm')}
                                    onChange={handleInputChange}
                                    checked={checkedValues}
                                />
                            </ul>
                        </div>
                        <div className="wrap-select-plus-child">
                            <div className="title-detailed">직급</div>
                            <ul className="tab-check-box">
                                <Checkbox
                                    name="ResumePosition"
                                    options={getOptions('ResumePosition')}
                                    onChange={handleInputChange}
                                    checked={checkedValues}
                                />
                            </ul>
                        </div>
                        <div className="wrap-select-plus-child">
                            <div className="title-detailed">급여</div>
                            <ul className="tab-check-box">
                                <Checkbox
                                    name="ResumePay"
                                    options={getOptions('ResumePay')}
                                    onChange={handleInputChange}
                                    checked={checkedValues}
                                />
                            </ul>
                        </div>
                        <div className="wrap-select-plus-child">
                            <div className="title-detailed">경력</div>
                            <div className="group">
                                <Radiobox
                                    name="ResumeCareer"
                                    options={getOptions('ResumeCareer')}
                                    onChange={handleInputChange}
                                    checked={checkedValues}
                                />
                                {Array.isArray(checkedValues.ResumeCareer) &&
                                    checkedValues.ResumeCareer.includes('009') && (
                                        <>
                                            (
                                            <Dropdown
                                                placeholder="경력기간선택"
                                                options={getOptions('ResumeCareerYear').filter(
                                                    (option) =>
                                                        parseInt(option.value, 10) <
                                                        parseInt(checkedValues.expMax || '999', 10),
                                                )}
                                                name={'ExpMin'}
                                                onChange={handleOptionChange}
                                            />
                                            ~
                                            <Dropdown
                                                placeholder="경력기간선택"
                                                options={getOptions('ResumeCareerYear').filter(
                                                    (option) =>
                                                        parseInt(option.value, 10) >
                                                        parseInt(checkedValues.expMin || '0', 10),
                                                )}
                                                name={'ExpMax'}
                                                onChange={handleOptionChange}
                                            />
                                            )
                                        </>
                                    )}
                            </div>
                        </div>
                        {/* <div className="wrap-select-plus-child">
                            <div className="title-detailed">채용기간</div>
                            <div className="group-datepicker">
                                <div className="datepicker-child">
                                    <DatePicker
                                        onChange={(date) => handleDateChange(date, 'startDate')}
                                        locale={'ko'}
                                        placeholderText={'YYYY/MM/DD'}
                                        dateFormat={'yyyy/MM/dd'}
                                        selected={startDate}
                                        maxDate={endDate || null}
                                    />
                                    <i className="icon icon-date" id="start-date-icon" />
                                </div>
                                <span>~</span>
                                <div className="datepicker-child">
                                    <DatePicker
                                        onChange={(date) => handleDateChange(date, 'endDate')}
                                        locale={'ko'}
                                        placeholderText={'YYYY/MM/DD'}
                                        dateFormat={'yyyy/MM/dd'}
                                        selected={endDate}
                                        minDate={startDate || null}
                                    />
                                    <i className="icon icon-date" id="end-date-icon" />
                                </div>
                            </div>
                        </div> */}
                        <div className="wrap-select-plus-child wrap-tabs-checkbox">
                            <div className="title-detailed" style={{ marginTop: '7px' }}>
                                지역
                            </div>
                            <ul className="tab-check-box" style={{ width: '100%' }}>
                                <div className="tabs-flex" style={{ flexDirection: 'column', width: '100%' }}>
                                    <div className="tabs-left" style={{ width: '100%' }}>
                                        <Tabs
                                            className="tabs-select-checkbox"
                                            tabs={tabCheckbox}
                                            onTabChange={handleTabtabSelectCheckbox}
                                            resetTrigger={resetTrigger}
                                            indexTabchange={activeTabCheckbox}
                                        />
                                        {arrTabCheckbox[activeTabCheckbox]?.length > 0 && (
                                            <>
                                                <ul>
                                                    <Radiobox
                                                        className="arrTabCheckbox"
                                                        name="RegionSi"
                                                        options={arrTabCheckbox[activeTabCheckbox]}
                                                        onChange={handleInputChange}
                                                        checked={{
                                                            ...checkedValues,
                                                            RegionSi: checkedValues.RegionSi || checkedRegionSi,
                                                        }}
                                                    />
                                                </ul>
                                            </>
                                        )}
                                    </div>
                                    <div className="tabs-right" style={{ paddingTop: '0px', width: '100%' }}>
                                        <form style={{ width: '100%' }}>
                                            {arrTabCheckbox[activeTabCheckbox] && (
                                                <>
                                                    <ul className="tabs-select-checkbox">
                                                        <Checkbox
                                                            name="RegionGu"
                                                            options={(communesToRenderTab3 || []).map((commune) => ({
                                                                id: 'regionGu_' + commune.code,
                                                                value: commune.code,
                                                                label: `${commune.codeName}`,
                                                            }))}
                                                            onChange={handleInputChange}
                                                            checked={{
                                                                ...checkedValues,
                                                                RegionGu: checkedValues.RegionGu || [],
                                                            }}
                                                        />
                                                    </ul>
                                                </>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>
                )}

                <div className="tab-select-results">
                    <ul className="results-area">
                        {checkedLabels.map((label, index) => (
                            <li key={index}>
                                <div className="item-search">{label}</div>
                                <span
                                    className="item-remove icon icon-x"
                                    onClick={() => handleRemoveLabel(label)}
                                ></span>
                            </li>
                        ))}
                    </ul>
                    <div className="wrap-option-search-block">
                        <button onClick={handleSearchClick}>
                            선택한 조건으로<span>검색하기</span>
                        </button>
                        <div className="wrap-option-search">
                            <div className="option-reset icon icon-reset" onClick={handleResetConditions}>
                                조건 초기화
                            </div>
                            <div className="option-save icon icon-pin" onClick={handleSaveConditions}>
                                조건 저장
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Content Table */}
            <div id="content-table">
                <div className="container">
                    <div className="wrap-table">
                        <div className="header-table-container">
                            <div className="top-table">
                                <div className="top-table-title">
                                    <h1>검색결과</h1>
                                    <span>Search Results 전체 {pages?.totalRow}건</span>
                                </div>
                                <div className="wrap-dropDown">
                                    {/* <div className="count-results blue">즉시지원만 보기</div> xóa theo yc slide sửa */}
                                    <div className="dropDowns">
                                        <Dropdown
                                            placeholder=""
                                            options={[
                                                { value: 'Seq', option: '등록일순' },
                                                { value: 'ModDate', option: '업데이트순' },
                                            ]}
                                            name="sortBy"
                                            value={sortBy}
                                            onChange={handleOptionChange}
                                        />
                                        <Dropdown
                                            placeholder=""
                                            options={[
                                                { value: 50, option: '50개씩 보기' },
                                                { value: 80, option: '80개씩 보기' },
                                                { value: 100, option: '100개씩 보기' },
                                            ]}
                                            name="size"
                                            value={size}
                                            onChange={handleOptionChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div
                                className="table table-header table-results"
                                style={{ gridTemplateColumns: 'calc(100% - 22% - 13%) 22% 13%' }}
                            >
                                <div className="column column-1">제목</div>
                                <div className="column column-2">경력/형태/자격증</div>
                                <div className="column column-3">수정</div>
                            </div>
                        </div>
                        <ResumeList
                            loading={loading}
                            results={results}
                            setResumeList={setResults}
                            resumeBanner={resumeBanner}
                            page={page}
                            dataConFig={dataConFig}
                            detailUrl="list"
                        />
                        <Pagination pages={pages} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default PAFAA010;
